<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="header">
      <div class="title">校园餐订单</div>
    </div>
    <div class="closeBtn" @click="close"></div>
    <div class="content">
      <a-table
        bordered
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :scroll="{ y: 1150 }"
        @change="onChange"
      >
        <template slot="materialNames" slot-scope="text">
          <div style="text-align:left;line-height:1.4em">{{ text }}</div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { groupOrderPage } from '@/api/dashboard'
import to from '@/utils/await-to'
export default {
  name: 'GroupOrderDialog',
  data() {
    return {
      visible: false,
      columns: [
        {
          title: '采购订单号',
          dataIndex: 'gmOrderId',
          key: 'gmOrderId',
          align: 'center',
          width: '12%',
        },
        {
          title: '采购主体名称',
          dataIndex: 'gmCustomerName',
          key: 'gmCustomerName',
          align: 'center',
          width: '18%',
        },
        {
          title: '期望送达时间',
          dataIndex: 'expectedDeliveryTime',
          key: 'expectedDeliveryTime',
          align: 'center',
          width: '12%',
        },
        {
          title: '下单机构',
          dataIndex: 'storeName',
          key: 'storeName',
          align: 'center',
          width: '10%',
        },
        {
          title: '采购商品',
          dataIndex: 'materialNames',
          key: 'materialNames',
          align: 'center',
          scopedSlots: { customRender: 'materialNames' },
          width: '25%',
        },
        {
          title: '下单金额',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
          align: 'center',
          width: '10%',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          align: 'center',
          width: '15%',
        },
        {
          title: '下单日期',
          dataIndex: 'orderTime',
          key: 'orderTime',
          align: 'center',
          width: '12%',
        },
      ],
      list: [],
      pagination: {
        current: 1,
        pageSize: 12,
        total: 0,
      },
    }
  },
  methods: {
    show() {
      this.visible = true
      this.pagination = {
        current: 1,
        pageSize: 12,
        total: 0,
      }
      this.initData()
    },
    close() {
      this.visible = false
    },
    async initData() {
      const [res, err] = await to(
        groupOrderPage({ current: this.pagination.current, size: this.pagination.pageSize }),
      )
      if (err) return
      this.list = res.data.list
      this.pagination.total = res.data.total
    },
    onChange({ current }) {
      this.pagination.current = current
      this.initData()
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3136px !important;
  height: 1638px !important;
  background: url('~@/img/agriculture/product_bg.png');
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;

  .header {
    display: flex;
    align-items: center;
    padding: 30px 0 0 60px;

    .title {
      font-size: 48px;
      color: #ffffff;
      font-weight: 500;
    }
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/agriculture/close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 120px 60px 0;
    height: calc(100% - 120px);

    ::v-deep .ant-table {
      p {
        margin-bottom: 10px;
      }

      table {
        border-left: 1px solid #0041b8;
        border-top: 1px solid #0041b8;
      }

      .ant-table-thead {
        box-sizing: border-box;
        border: 0;
        border-color: #f2f2f2;
        font-size: 36px;
        line-height: 36px;
        background: rgba(5, 88, 159, 0.8);

        > tr > th {
          background: transparent;
          color: #fff;
          border-color: #f2f2f2;
          padding-top: 30px;
          padding-bottom: 30px;
        }
      }

      .ant-table-header {
        background: transparent;
      }

      .ant-table-body {
        background: transparent;

        &::-webkit-scrollbar {
          border-radius: 15px;
          width: 12px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-track {
          border-radius: 15px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 15px;
          background: #0041b8;
        }
      }

      .ant-table-tbody {
        font-size: 34px;
        line-height: 34px;
        color: #fff;

        > tr > td {
          border-color: #f2f2f2;
          padding-top: 24px;
          padding-bottom: 24px;
          background: rgba(0, 40, 40, 0.3);
        }

        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: rgba(0, 170, 136, 0.2);
        }
      }

      .ant-table-placeholder {
        background: transparent;
      }
    }

    ::v-deep .ant-pagination {
      width: 100%;
      text-align: center;
      padding-top: 30px;

      .ant-pagination-prev,
      .ant-pagination-next {
        width: auto;
        height: 50px;
        line-height: 50px;
        border: none;
        background: transparent;

        .ant-pagination-item-link {
          color: #fff;
          font-size: 24px;
          background: transparent;
          border: none;
        }

        &.ant-pagination-disabled {
          .ant-pagination-item-link {
            color: #666;
          }
        }
      }

      > li {
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        border: 2px solid #0041b8;
        font-weight: normal;
        font-size: 24px;
        line-height: 46px;
        text-align: center;
        background-color: transparent;
        margin: 0 8px;

        a {
          color: #0041b8;
        }

        &.ant-pagination-item-active {
          background-color: #0041b8;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: translate(-50%, -50%) scale(0);
    }

    100% {
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
